<template>
    <h3 class="txt-uppercase">Required Collateral</h3>
    <table>
      <tbody>
        <tr>
          <td class="txt-left color-white">Total TVL - 100%</td>
          <td class="txt-right color-white">${{ collateral }}</td>
        </tr>
        <tr>
          <td class="txt-left"
            :class="{'color-purple-xxlight': isNativeCollateral}"
          >
            {{ activeNetwork.ticker }} TVL - {{ collateralRateNative() }}%
          </td>
          <td class="txt-right"
            :class="{'color-purple-xxlight': isNativeCollateral}"
          >
            ${{ NATIVEcollateral }}
          </td>
        </tr>

        <tr>
          <td class="txt-left"><span class="txt-uppercase">Stable</span> TVL - {{ collateralRateUSD() }}%</td>
          <td class="txt-right">${{ USDcollateral }}</td>
        </tr>

        <tr
          v-if="collateralFAssetIsActive"
        >
          <td class="txt-left">
            <span class="txt-uppercase">BTC/ETH</span> TVL - {{ collateralRateFAsset() }}%
          </td>
          <td class="txt-right">${{ FASSETcollateral }}</td>
        </tr>


      </tbody>
    </table>

    <h3 class="txt-uppercase">{{ coin.ticker }} Details</h3>
    <table>
      <tbody>
        <tr>
          <td class="txt-left">Circulating Supply</td>
          <td class="txt-right">{{ circulatingSupply }}</td>
        </tr>
        <tr>
          <td 
            class="txt-left"
            :class="{'color-purple-xxlight' : showPriceSimulator}"
            v-if="!showPriceSimulator"
          >
            Market Price
          </td>
          <td 
            class="txt-left"
            :class="{'color-purple-xxlight' : showPriceSimulator}"
            v-else
          >
            Price Speculation
          </td>
          <td 
            class="txt-right"
            :class="{'color-purple-xxlight' : showPriceSimulator}"
          >
            ${{ currencyFormatter(mPrice) }}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="container">
      <div class="toggle-container">
        <p 
          class="txt-uppercase"
          :class="{'toggle-active' : showPriceSimulator}"
        >
        {{ coin.ticker }} Price Speculator
        </p>
        <ToggleSwitch
          :id="1"
          :classes="'price-toggle'"
          :modelValue="showPriceSimulator"
          :activeNetwork="activeNetwork"
          @updateToggleSwitch="clicked($event)"
        />
      </div>
      <Transition>
        <InputRangePrice
          v-if="showPriceSimulator"
          :constant="constant"
          :coin="coin"
          :configs="configs"
          @updateModifiedCoinPrice="updateModifiedCoinPrice($event)"
        />
      </Transition>
    </div>

</template>
<script setup>
  import { ref, computed } from 'vue'
  import InputRangePrice from '../_generics/InputRangePrice.vue'
  import ToggleSwitch from '../_generics/ToggleSwitch.vue'

  const props = defineProps({
    constant: {
      type: Object,
      default: () => {}
    },
    coin: {
      type: Object,
      default: () => {}
    },
    configs: {
      type: Object,
      default: () => {}
    },
    activeNetwork: {
      type: Object,
      default: () => {}
    },
    collateral: {
      type: String,
      default: ''
    },
    isNativeCollateral: {
      type: Boolean,
      default: false
    },
    circulatingSupply: {
      type: String,
      default: ''
    },
    USDcollateral: {
      type: String,
      default: ''
    },
    NATIVEcollateral: {
      type: String,
      default: ''
    },
    FASSETcollateral: {
      type: String,
      default: ''
    },
    collateralFAssetIsActive: {
      type: Boolean,
      default: false
    },
    networkCollateralAllocation: {
      type: Array,
      default: () => []
    },
  })

  const emit = defineEmits([
    'updateModifiedCoinPrice'
  ])

  const constant = props.constant
  const showPriceSim = ref(false)

  const mPrice = computed(() => {
    return props.coin.modifiedPrice > 0 ? props.coin.modifiedPrice : props.coin.price
  })

  const showPriceSimulator = computed (() => {
    const show =  showPriceSim.value || props.coin.modifiedPrice > 0
    if(show) {
      showPriceSim.value = show
    }
    return show
  })

  const collateralRateUSD = () => {
    return parseFloat(props.networkCollateralAllocation[0].set * 100).toFixed(0)
  }

  const collateralRateNative = () => {
    if(props.collateralFAssetIsActive) {
    return parseFloat(props.networkCollateralAllocation[2].set * 100).toFixed(0)
    }
    return parseFloat(props.networkCollateralAllocation[1].set * 100).toFixed(0)
  }

  const collateralRateFAsset = () => {
    if(props.collateralFAssetIsActive) {
      return parseFloat(props.networkCollateralAllocation[1].set *100).toFixed(0)
    }
    return 0
  }

  const clicked = (event) => {
    showPriceSim.value = !showPriceSim.value

    const mCoin = {
      id: props.coin.id,
      modifiedPrice: 0
    }
    emit('updateModifiedCoinPrice', mCoin)
  }

  const updateModifiedCoinPrice = (event) => {
    emit('updateModifiedCoinPrice', event)
  }

  const currencyFormatter = (value) => {
    return value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
  }
</script>
<style lang="scss" scoped>
  @import '../../assets/scss/_variables.scss';

  h3 {
    margin-top: 10px;
    font-size: $FONT-XSMALL;
    font-weight: normal;
    padding-bottom: 10px;
    
    &:first-child {
      margin-top: 30px;
    }
  }

  table {
    font-size: $FONT-XXSMALL;

    tr {
      &:last-child {
        color: $GREY-LIGHT;
      }
    }
  }

  .container {
    position: relative;
    flex-direction: column;
    background-color: $BLACK-LIGHT;
    margin: 20px 0px;
    padding: 10px 0;
    height: auto;

    .toggle-container{
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      p {
        font-size: $FONT-XSMALL;
        margin-left: 3px;
        color: $GREY-LIGHT;

        &.toggle-active {
          color: $WHITE;
        }
      }

      .price-toggle[type="checkbox"] {
          background-color: $GREY-XLIGHT;
        
        &:not(:checked) {
          &::before{
            background-color: $GREY-XXXXLIGHT;
          }
        }

        &:checked[type="checkbox"] {
          background-color: $WHITE;

          &::before {
            background-color: $PURPLE;
          }
        }
      }
    }
  }

  .v-enter-from {
    height: 0;
  }
  .v-enter-to {
    height: $PRICE-SIMULATOR-HEIGHT;
  }
  .v-enter-active {
    transition: height 0.15s ease-in;
  }

  .v-leave-from {
    height: $PRICE-SIMULATOR-HEIGHT;
  }
  .v-leave-to {
    height: 0;
  }
  .v-leave-active{
    transition: height 0.15s ease-out;
  }
</style>